var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPermissions = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "permissions-a",
  points: "0 .624 13.876 .624 13.876 14.169 0 14.169"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.5801,4.5215 L13.8751,1.8175 C13.5911,1.5335 13.2131,1.3765 12.8111,1.3765 L8.5171,1.3765 C7.9641,1.3765 7.5171,1.8245 7.5171,2.3765 C7.5171,2.9285 7.9641,3.3765 8.5171,3.3765 L12.6051,3.3765 L13.6061,4.3765 L12.2701,4.3765 L12.2701,6.3765 L15.0201,6.3765 L15.0201,16.3765 L4.0201,16.3765 L4.0201,11.3765 C4.0201,10.8245 3.5731,10.3765 3.0201,10.3765 C2.4681,10.3765 2.0201,10.8245 2.0201,11.3765 L2.0201,16.8795 C2.0201,17.7055 2.6911,18.3765 3.5171,18.3765 L15.5241,18.3765 C16.3501,18.3765 17.0201,17.7055 17.0201,16.8795 L17.0201,5.5855 C17.0201,5.1835 16.8641,4.8055 16.5801,4.5215"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .377)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "permissions-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#permissions-a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.8281,4.1216 L3.1211,4.8286 C2.7301,5.2196 2.7301,5.8516 3.1211,6.2426 C3.3161,6.4376 3.5721,6.5356 3.8281,6.5356 C4.0841,6.5356 4.3401,6.4376 4.5351,6.2426 L5.2421,5.5356 L10.8991,11.1926 L9.0491,13.0436 L12.2281,14.1036 C12.3601,14.1476 12.4941,14.1686 12.6271,14.1686 C12.9531,14.1686 13.2691,14.0406 13.5101,13.8016 C13.8471,13.4646 13.9621,12.9736 13.8101,12.5216 L13.3001,10.9896 C13.2261,10.7696 13.1011,10.5666 12.9371,10.4026 L3.8651,1.3306 L3.0831,0.6236 L0.2931,3.4136 C-0.0979,3.8046 -0.0979,4.4376 0.2931,4.8286 C0.6831,5.2186 1.3161,5.2186 1.7071,4.8286 L3.1201,3.4136 L3.8281,4.1216 Z",
  mask: "url(#permissions-b)"
})))));
export default SvgPermissions;